import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel, Select, SelectItem } from '../../../../../shared';
import { StorySyncSource } from '../StorySync';

import classes from './StorySyncRow.module.scss';

const FETCH_LAST_ITEMS_OPTIONS = [0, 2, 5, 10, 15, 20, 50, 75, 100].map((item) => {
  return { id: item, title: item.toString() };
});

interface StorySyncRowProps {
  source: StorySyncSource;
  channelItems: SelectItem<number>[];
  storyItems: SelectItem<number>[];
  disabled: boolean;
  withFetchLastItems: boolean;
  onChange: (source: StorySyncSource) => void;
  onRemove: () => void;
}

export const StorySyncRow: FunctionComponent<StorySyncRowProps> = ({
  source,
  channelItems,
  storyItems,
  disabled,
  withFetchLastItems,
  onChange,
  onRemove,
}) => {
  const { t } = useTranslation();

  const { channelId, storyId, fetchLastCards } = source;

  return (
    <div className={classes['story-sync-row']}>
      <Select
        label={t(`common.${channelItems.length ? 'channel' : 'no-channel-available'}`)}
        disabled={disabled || !channelItems.length}
        items={channelItems}
        selectedItemId={channelId}
        listMaxHeightRem={19.5}
        className={classes['story-sync-row__channel']}
        onChange={(channelId) => onChange({ channelId, fetchLastCards })}
      />

      <Select
        label={t(`common.${storyItems.length ? 'story' : 'no-story-available'}`)}
        disabled={disabled || !storyItems.length}
        items={storyItems}
        selectedItemId={storyId}
        listMaxHeightRem={13.5}
        className={classes['story-sync-row__story']}
        onChange={(storyId) => onChange({ ...source, storyId })}
      />

      {withFetchLastItems && (
        <Select
          label={t('common.fetch-last-items')}
          items={FETCH_LAST_ITEMS_OPTIONS}
          listMaxHeightRem={13.5}
          selectedItemId={fetchLastCards}
          disabled={disabled}
          className={classes['story-sync-row__fetch']}
          onChange={(lastCards) => onChange({ ...source, fetchLastCards: lastCards ?? 0 })}
        />
      )}

      <IconLabel
        className={classes['story-sync-row__remove']}
        iconId={'close'}
        iconSize={20}
        ariaLabel={t('common.remove')}
        color={'#888888'}
        disabled={disabled}
        onClick={onRemove}
        singleColor
      />
    </div>
  );
};
